import { Label } from "~/atoms/label";
import { Switch } from "~/atoms/switch";

interface Props {
  label: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

const SwitchWithLabel = ({ label, checked, onCheckedChange }: Props) => (
  <div className="flex h-8 shrink-0 items-center gap-2 rounded-lg border px-2">
    <Switch checked={checked} onCheckedChange={onCheckedChange} />
    <Label>{label}</Label>
  </div>
);

export default SwitchWithLabel;
